import React from 'react';
import { Button } from 'semantic-ui-react';
import {useSelector} from 'react-redux';

import { getShippingMethod, getShippingType } from './ShippingCard/reducer';
import { getDiscount } from './CouponCard/reducer';

import {
    ADDRESS_FIRSTNAME,
    ADDRESS_LASTNAME,
    ADDRESS_PHONE_COUNTRY,
    ADDRESS_PHONE,
    ADDRESS_EMAIL,
    ADDRESS_IS_JURIDIC,
    ADDRESS_COMPANY,
    ADDRESS_COMPANY_INN,
    ADDRESS_COMPANY_KPP,
    ADDRESS_COMPANY_OGRN,
    ADDRESS_COMPANY_CHIEF_NAME,
    ADDRESS_COMPANY_CONTACT_NAME,
    ADDRESS_COMPANY_JOB_TITLE,
    ADDRESS_COMPANY_SCOPE,
    ADDRESS_COMPANY_LEGAL_ADDR,
    ADDRESS_COMPANY_POST_ADDR,
} from './AddressCard/actions';
import { getAddressFields} from './AddressCard/reducer';
import {getPaymentMethod} from "../views/Checkout_2_StepPayment/reducer";
import {getCartItems, hasOnlyVirtuals} from "../views/Cart/reducer";
import {putOrder} from "../views/Orders/actions";

export default function ConfirmOrderButton(props) {

    const {dispatch, token, userData, userLocation, mixpanel, navigate} = props;

    const cart_items = useSelector((state) => getCartItems(state.cart));
    const only_virtuals = useSelector((state) => hasOnlyVirtuals(state.cart));
    const coupon  = useSelector((state) => getDiscount(state.discount));

    const shipping_type = only_virtuals? '' : useSelector((state) => getShippingType(state.shipping));
    const shipping_method = only_virtuals ? '' : useSelector((state) => getShippingMethod(state.shipping));
    const address_fields = useSelector((state) => getAddressFields(state.address));
    const payment_option = useSelector((state) => getPaymentMethod(state.payment));

    const orderData = {
        user_location: JSON.stringify({
            userData: {id: userData.id, login: userData.login},
            userLocation,
        }),

        shipping_type,
        shipping_method,

        coupon,

        payment_option,

        create_account: '0',

        cart_items: JSON.stringify(cart_items),

        billing : JSON.stringify({
            first_name: address_fields[ADDRESS_FIRSTNAME],
            last_name: address_fields[ADDRESS_LASTNAME],
            phone_country: address_fields[ADDRESS_PHONE_COUNTRY],
            phone: address_fields[ADDRESS_PHONE],
            email: address_fields[ADDRESS_EMAIL] ?? '',
            is_juridic: address_fields[ADDRESS_IS_JURIDIC],
            company: address_fields[ADDRESS_COMPANY] ?? '',
            company_inn: address_fields[ADDRESS_COMPANY_INN] ?? '',
            company_kpp: address_fields[ADDRESS_COMPANY_KPP] ?? '',
            company_ogrn: address_fields[ADDRESS_COMPANY_OGRN] ?? '',
            company_chief_name: address_fields[ADDRESS_COMPANY_CHIEF_NAME] ?? '',
            company_contact_name: address_fields[ADDRESS_COMPANY_CONTACT_NAME] ?? '',
            company_job_title: address_fields[ADDRESS_COMPANY_JOB_TITLE] ?? '',
            company_scope: address_fields[ADDRESS_COMPANY_SCOPE] ?? '',
            company_legal_address: address_fields[ADDRESS_COMPANY_LEGAL_ADDR] ?? '',
            company_post_address: address_fields[ADDRESS_COMPANY_POST_ADDR] ?? '',
        }),
    };

    function handleClick() {

        //console.log('place order', orderData);
        dispatch(putOrder(token, orderData, navigate, props.pathToRoute));

        if (mixpanel)
            mixpanel.track('Checkout Place Order', {
                ...userLocation, ...userData,
                payment_option, ...address_fields,
                cart_items
            });
    }

    return (
        <Button
            color="green"
            className= {`${props.addClassName} button-confirm`}
            onClick={handleClick}
            disabled={props.disabled ?? false}
        >
            {props.buttonText}
        </Button>
    );
}